/* istanbul ignore file */
import React, { useContext } from 'react';
import {
  AlertLayoutProps,
  ButtonLayoutProps,
  FadeLayoutProps,
  InputLoaderLayoutProps,
  LoadingLayoutProps,
  SmallLoaderLayoutProps,
  TooltipLayoutProps,
} from 'framework/ui/uiContract';
import type { BadgeLayoutProps } from 'framework/ui/uiContract';
import { Timezone } from 'framework/types';

interface BaseTheme {
  Alert: ReactComponent<AlertLayoutProps>;
  Tooltip: ReactComponent<TooltipLayoutProps>;
  Button: ReactComponent<ButtonLayoutProps>;
  Fade: ReactComponent<FadeLayoutProps>;
  Loading: ReactComponent<LoadingLayoutProps>;
  SmallLoader: ReactComponent<SmallLoaderLayoutProps>;
  InputLoader: ReactComponent<InputLoaderLayoutProps>;
  Badge: ReactComponent<BadgeLayoutProps>;
}

export type ApplicationTheme<T extends ReactComponent<any>> = BaseTheme & {
  [key: string]: T;
};

interface ApplicationConfig {
  defaultPageTitle?: string;
  getTimezone: () => string | Promise<Nullable<Timezone>>;
  theme: ApplicationTheme<any>;
  useDefaultTextTransformer: () => {
    mapTags: (description: any) => any;
    mapAsyncTags: (description: any) => Promise<any>;
  };
}

const ApplicationSettingsContext = React.createContext<Partial<ApplicationConfig>>({});

export const ApplicationSettingsProvider = ApplicationSettingsContext.Provider;

const useApplicationSettings = () => useContext(ApplicationSettingsContext);

interface ApplicationSettingsProps {
  defaultPageTitle?: string;
  getTimezone: () => string | Promise<Nullable<Timezone>>;
  theme: ApplicationTheme<any>;
  children: React.ReactNode;
  useDefaultTextTransformer: () => {
    mapTags: (description: any) => any;
    mapAsyncTags: (description: any) => Promise<any>;
  };
}

export const ApplicationSettings: React.FC<ApplicationSettingsProps> = ({
  theme,
  getTimezone = undefined,
  children,
  useDefaultTextTransformer,
}) => {
  return (
    <ApplicationSettingsProvider
      value={{
        theme,
        getTimezone,
        defaultPageTitle: 'DaVinci',
        useDefaultTextTransformer,
      }}
    >
      {children}
    </ApplicationSettingsProvider>
  );
};

export default useApplicationSettings;
